module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_mart.ver2_0_2.png?41267d03";